import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AdminNotificationActionService {
    subject$: Subject<NotificationAction> = new Subject<NotificationAction>();
}

export class NotificationAction {
    type: NotificationActionType;
    payload?: any;
}

export enum NotificationActionType {
    DELETE_NOTIFICATION = 'DELETE_NOTIFICATION',
    ACTIVE_NOTIFICATION = 'ACTIVE_NOTIFICATION',
}
